export const ACCOUNT_REQUEST_STATUS_KID = 'K_NODE;ACCOUNT_REQUEST_STATUS';
export const STATUS_TODO = 'K_NODE;ACC_REQ_STATUS_TODO';
export const STATUS_WAITING = 'K_NODE;ACC_REQ_STATUS_WAITING';
export const STATUS_DONE = 'K_NODE;ACC_REQ_STATUS_DONE';
export const STATUS_READY = 'K_NODE;ACC_REQ_STATUS_READY';

export const COMPOSED_OF = 'K_NODE;COMPOSED_OF';
export const COMPONENT_OF = 'K_NODE;COMPONENT_OF';
export const LIKE = 'K_NODE;LIKE';
export const DEFINED_BY = 'K_NODE;DEFINED_BY';
export const INHERITS = 'K_NODE;INHERITS';
export const ELEMENT_OF = 'K_NODE;ELEMENT_OF';
export const IS_A = 'K_NODE;IS_A';
